import { SVGProps } from '@components/Icon/types';

export const Pan = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(2.4, 2.4)">
      <path
        d="M6.17574 4.02426C6.41005 4.25858 6.78995 4.25858 7.02427 4.02426L8.85001 2.19853V8.84999H2.19854L4.02426 7.02426C4.25858 6.78995 4.25858 6.41005 4.02426 6.17574C3.78995 5.94142 3.41005 5.94142 3.17574 6.17574L0.175736 9.17574C-0.0585786 9.41005 -0.0585786 9.78995 0.175736 10.0243L3.17574 13.0243C3.41005 13.2586 3.78995 13.2586 4.02426 13.0243C4.25858 12.7899 4.25858 12.4101 4.02426 12.1757L2.19852 10.35H8.85001V17.0015L7.02427 15.1757C6.78995 14.9414 6.41005 14.9414 6.17574 15.1757C5.94142 15.41 5.94142 15.7899 6.17574 16.0243L9.17574 19.0243C9.41005 19.2586 9.78995 19.2586 10.0243 19.0243L13.0243 16.0243C13.2586 15.7899 13.2586 15.41 13.0243 15.1757C12.79 14.9414 12.4101 14.9414 12.1757 15.1757L10.35 17.0015V10.35H17.0015L15.1757 12.1757C14.9414 12.4101 14.9414 12.7899 15.1757 13.0243C15.41 13.2586 15.7899 13.2586 16.0243 13.0243L19.0243 10.0243C19.2586 9.78995 19.2586 9.41005 19.0243 9.17574L16.0243 6.17574C15.7899 5.94142 15.41 5.94142 15.1757 6.17574C14.9414 6.41005 14.9414 6.78995 15.1757 7.02426L17.0015 8.84999H10.35V2.19853L12.1757 4.02426C12.4101 4.25858 12.79 4.25858 13.0243 4.02426C13.2586 3.78995 13.2586 3.41005 13.0243 3.17574L10.0243 0.175736C9.78995 -0.0585786 9.41005 -0.0585786 9.17574 0.175736L6.17574 3.17574C5.94142 3.41005 5.94142 3.78995 6.17574 4.02426Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'pan';
